import { useState, useEffect } from 'react';
import { Conditional } from 'common/components/layout';
import styles from './SignatureStatus.scss';
import classnames from 'classnames';
import lodash from 'lodash';

const SignatureStatus = ({ signatureExpectations }) => {
    const [manageSignature, setManageSignature] = useState(false);
    
    useEffect(() => {
        if(!lodash.isEmpty(signatureExpectations))   {
            setManageSignature(true);
        }
        return () => {
            setManageSignature(false);
        };
    }, [signatureExpectations]);
    
    const renderSignatures = () => {
        const signatureCount = signatureExpectations.filter(
            (expectation) => expectation.signatureStatus === 'PENDING'
        ).length;
        return (
            <div>
                { signatureCount === 0
                    ? <div className={classnames(styles.container, styles.complete)}>COMPLETE</div>
                    : <div className={classnames(styles.container, styles.pending)}>{`${signatureCount} OUTSTANDING`}</div>
                }
            </div>
        );
    };
    return (
        <Conditional condition={manageSignature}>
            {renderSignatures()}
        </Conditional>
    );
};
 
export default SignatureStatus;